import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px 15px;
  gap: 20px;
`;

export const Text = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.tertiary.labels};
`;
